import { render } from "./OnWifiUser.vue?vue&type=template&id=c190628a&scoped=true"
import script from "./OnWifiUser.vue?vue&type=script&lang=js"
export * from "./OnWifiUser.vue?vue&type=script&lang=js"

import "./OnWifiUser.vue?vue&type=style&index=0&id=c190628a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c190628a"]])

export default __exports__